import axios from 'axios'
import store from '@/store'
import config from './config'

export const post = async (url, params) => {
  try {
	  const result = await axios({
	  	method: 'POST',
	  	url: config.api + url,
	  	headers: {
	    	'Content-Type': 'application/json'
	  	},
	  	data: params
	  });
	  return result.data;
	} catch (err) {
		if (err.response && err.response.status && err.response.status === 403) {
			store.dispatch('setCallbackUrl', window.location.hash.replace('#', ''))
      window.location.href = '/#/login';
    }
		throw err;
	}
}
export const get = async url => {
  try {
    const result = await axios({
      method: 'GET',
      url: config.api + url
    });
    return result.data;
  } catch (err) {
		if (err.response && err.response.status && err.response.status === 403) {
      window.location.href = '/#/login';
    }
    throw err;
  }
}
// const postFn = (m, p) => {
//   const f = {
//     method: m,
//     params: [p]
//   }
//   return JSON.stringify(f);
// }
